import { render, staticRenderFns } from "./EmptyDataRow.vue?vue&type=template&id=1d99b388&scoped=true&"
import script from "./EmptyDataRow.vue?vue&type=script&lang=js&"
export * from "./EmptyDataRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d99b388",
  null
  
)

export default component.exports